import { useReveal } from "../lib/useReveal";
import { CircleCheck } from "lucide-react";

const ITEMS = [
  {
    title: "Radical Transparency",
    body: "Every rupee is accounted for. Fund utilisation is published, and every donor receives regular, plain-language updates from the field.",
  },
  {
    title: "Ground-Level Implementation",
    body: "We do not sub-contract impact. Our team lives inside the schools we adopt, visits weekly, and reports back to donors school by school.",
  },
  {
    title: "Long-Term Adoption Model",
    body: "We do not do one-off drives. Each adopted school is a multi-year commitment — teachers, hygiene, teaching aids and monitoring — for as long as it takes.",
  },
  {
    title: "Community as Partner",
    body: "The gram panchayat, headmaster, teachers and parents are our partners — not our beneficiaries. Every intervention is co-designed on the ground.",
  },
];

export default function Values() {
  const ref = useReveal();
  return (
    <section id="values" data-testid="values-section" className="relative py-16 md:py-28 bg-parchment">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="reveal max-w-3xl text-center md:text-left mx-auto md:mx-0">
          <span className="section-chip">Why Akshara Daana</span>
          <h2 className="mt-3 font-display font-extrabold text-navy text-3xl sm:text-4xl md:text-5xl leading-[1.1] tracking-tight">
            Why <em>Akshara Daana?</em>
          </h2>
          <p className="mt-4 text-indigo/80 font-display text-base md:text-lg leading-relaxed">
            We are a small, unhurried project. What we can promise is transparency, patience and presence —
            and a rare refusal to look away when the work gets slow or unglamorous.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {ITEMS.map((it) => (
            <div key={it.title} data-testid={`value-${it.title.replace(/\s+/g, "-").toLowerCase()}`} className="manuscript-card">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-banyan text-parchment flex items-center justify-center shrink-0">
                  <CircleCheck className="w-5 h-5" />
                </div>
                <div className="min-w-0">
                  <h3 className="font-display font-bold text-navy text-xl leading-snug">{it.title}</h3>
                  <p className="mt-1.5 text-indigo/75 font-display text-sm md:text-base leading-relaxed">{it.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
